import { gql } from "gql";

export const GET_BPM_ROLE_ASSIGNMENT_LIST = gql(/* GraphQL */ `
  query GetBpmRoleAssignmentList {
    getHrRoleAssignmentList {
      ...BpmRolesListRecord
    }
  }
`);
